export type TextContentItem = {
    subheader: string;
    body: string[];
}

export enum SiteSection {
    Hospitality = "Hospitality",
    RealEstate = "Real Estate",
    SeniorLiving = "Senior Living",
    Support = "Support",
    Pricing = "Pricing"
}

export type SiteColors = {
    Primary: string;
    Secondary: string;
    Tertiary: string;
    Quaternary: string;
    Quinary: string;
}

export enum Content {
    LandingImageCard,
    AccordionCard,
    ImageGridCard,
    ContentCard
}

export type MenuContentComponent = any;

export type EcommerceItem = {
    item_id: string;
    item_name: string;
    price: number;
    quantity: number;
}

export type EcommerceEvent = {
    currency: string;
    transaction_id: string;
    value: number;
    coupon?: string;
    items: EcommerceItem[];
    credit_card_entered: boolean;
}